(function () {
  var activeTypes = {
    email: 1,
    mobile: 2
  };

  var baseSignUpModel = {
    ui: {
      baseSignUp: true,
      signUp: {
        base: false,
        setEmailPassword: false,
        setMobilePassword: false,
        mobileConfirmation: false,
        mobileFinal: false,
        emailFinal: false
      },
      signIn: {
        mobile: false,
        email: false,
        needTwoStepVerification: false,
        dynamicPassword: false,
        dynamicPasswordToEmail: false,
        staticPassword: false
      },
      recovery: {
        base: false,
        mobile: false,
        email: false,
        changePassword: false,
        mobileFinal: false,
        emailFinal: false
      }
    },

    logic: {
      signIn: {
        byEmail: true,
        byMobile: true,
        email: null,
        mobile: null,
        key: null,
        dynamicPasswordToken: null,
        isActiveResendButton: false,
        isLoadingResendButton: false
      },
      signUp: {
        mobile: null,
        email: null,
        success: false,
        key: null,
        code: null,
        isActiveResendButton: false,
        isLoadingResendButton: false
      },
      recovery: {
        key: null,
        isActiveResendButton: false,
        isLoadingResendButton: false
      },
      url: {
        return: null,
        //signIn
        signInByEmail: null,
        signInByMobile: null,
        verifyTwoFactorMobileTokenAndSignIn: null,
        verifyTwoFactorEmailTokenAndSignIn: null,
        sendDynamicMobilePassword: null,
        //signUp
        sendMobileVerificationCode: null,
        verifyMobileVerificationCode: null,
        signUpByEmail: null,
        signUpByMobile: null,
        signUpByMobileAndSetPassword: null,
        findUserByMobile: null,
        findUserByEmail: null,
        verifyMobileVerificationCodeAndSetPassword: null,
        //recovery
        sendRecoveryAccountCodeByEmail: null,
        sendDynamicEmailPassword: null,
        sendRecoveryAccountCodeByMobile: null,
        verifyRecoveryAccountCodeByMobile: null,
        VerifyRecoveryAccountCodeByMobileAndChangePassword: null,
        //companies
        getCompanies: null,
        companies: null
      },
      loading: false
    }
  };

  window.SignUp = function (signUpModel) {
    Object.assign(baseSignUpModel, signUpModel);
    var currentForm = null;
    var historyModels = [];
    var sectionTypes = {
      signIn: 1,
      signUp: 2,
      recovery: 3
    };

    var passwordTypes = {
      static: 0,
      dynamic: 1
    };

    $(".js-sign-up-modal input").keyup(function (e) {
      var temp = convertFaToEnNumber(e.target.value);

      $(this).val(temp);
    });

    var firstUiModel = JSON.parse(JSON.stringify(baseSignUpModel.ui));

    $(".js-sign-up-sign-in-create-account").click(createAccount);
    $(".js-sign-in-mobile-start-recovery").click(startRecoveryByMobileInSignIn);
    $(".js-sign-up-sign-in-start-recovery").click(startRecoveryInSignUpSignIn);
    $(".js-sign-in-mobile-send-dynamic-password").click(sendDynamicPassword);
    $(".js-sign-in-mobile-static-password").click(signInStaticPasswordMobile);
    $(".js-sign-in-static-password").click(signInStaticPasswordPage);
    $(".js-sign-in-dynamic-password").click(enterAccountForSignIn);
    $(".js-sign-in-email-static-password").click(signInStaticPasswordEmail);
    $(".js-sign-in-mobile-dynamic-password-re-send").click(
      sendDynamicPasswordAgain
    );
    $(".js-sign-in-email-dynamic-password-re-send").click(
      sendDynamicPasswordAgainWithEmail
    );

    $(".js-sign-up-mobile-confirmation-re-send").click(
      sendMobileVerificationCode
    );
    $(".js-recovery-account-re-send-mobile-code").click(
      reSendMobileRecoveryCode
    );
    $(".js-back").click(goBack);

    $(".js-sign-up-form form").submit(function (event) {
      event.preventDefault();

      if (baseSignUpModel.logic.loading) {
        return;
      }

      if (!$(this).valid()) {
        return;
      }

      currentForm = $(this);

      var formClassName = $(this).attr("class");

      var emailOrMobile = convertFaToEnNumber(
        $(this).find("[name$='EmailOrMobile']").val()
      );

      var email = convertFaToEnNumber($(this).find("[name$='Email']").val());

      var password = convertFaToEnNumber(
        $(this).find("[name$='Password']").val()
      );

      var confirmPassword = convertFaToEnNumber(
        $(this).find("[name$='ConfirmPassword']").val()
      );

      var code = convertFaToEnNumber($(this).find("[name$='Code']").val());

      var mobile = convertFaToEnNumber($(this).find("[name$='Mobile']").val());

      var countryCode =
        $(this).find(".js-country-code-placeholder").val() ||
        window.countryCode;

      if (window.countryCode === null || window.countryCode === undefined) {
        window.countryCode = countryCode;
      }

      switch (formClassName) {
        case "js-sign-up-sign-in-static-password":
          enterAccountForStaticPass(emailOrMobile);
          break;
        case "js-sign-in-email-password-continue":
          signInByEmail(password);
          break;
        case "js-sign-in-mobile-continue":
          signInByMobile(password);
          break;
        case "js-sign-in-staticPassword":
          signInByStaticPass(mobile, email, countryCode, password);
          break;
        case "js-sign-in-mobile-dynamic-password-continue":
          signInByDynamicPassword(password);
          break;
        case "js-sign-in-mobile-dynamic-password-login":
          signInByDynamicPasswordWithMobile(code);
          break;
        case "js-sign-in-email-dynamic-password-login":
          signInByDynamicPasswordWithEmail(code);
          break;
        case "js-sign-in-email-dynamic-password-continue":
          signInByDynamicPassword(password);
          break;
        case "js-recovery-account-send-mobile-code":
          sendMobileRecoveryCode(mobile, countryCode);
          break;
        case "js-recovery-account-mobile-continue":
          verifyMobileRecoveryCode(code, countryCode);
          break;
        case "js-sign-up-mobile-continue":
          signUpUserNotFindByMobile(mobile);
          break;
        case "js-sign-up-email-continue":
          signUpUserNotFindByEmail(email);
          break;
        case "js-recovery-account-send-email-link":
          sendEmailRecoveryLink(email);
          break;
        case "js-sign-up-mobile-confirmation-continue":
          VerifyMobileVerificationCode(code);
          break;
        case "js-sign-up-mobile-set-password-confirm-continue":
          signUpByMobileAndSetPassword(password, confirmPassword);
          break;
        case "js-sign-up-email-set-password-continue":
          signUpByEmail(password, confirmPassword);
          break;
        case "js-sign-up-mobile-confirmation-set-password-continue":
          verifyMobileVerificationCodeAndSetPassword(password, confirmPassword);
          break;
        case "js-recovery-account-change-password-continue":
          verifyMobileRecoveryCodeAndChangePassword(password, confirmPassword);
          break;
      }
    });

    function updateView() {
      $(".js-sign-up-sign-in").toggle(baseSignUpModel.ui.baseSignUp);
      // fill values inside inputs of this form before shows to user
      if (baseSignUpModel.ui.baseSignUp) {
        if (baseSignUpModel.logic.signIn.mobile) {
          $(".js-sign-up-sign-in").find("form input#Mobile").val(baseSignUpModel.logic.signIn.mobile);
        }
     
        if (baseSignUpModel.logic.signIn.email) {
          $(".js-sign-up-sign-in").find("form input#Email").val(baseSignUpModel.logic.signIn.email);
        }
      }

      $(".js-sign-up").toggle(baseSignUpModel.ui.signUp.base);

      $(".js-sign-in-mobile").toggle(baseSignUpModel.ui.signIn.mobile);

      $(".js-sign-in-static").toggle(baseSignUpModel.ui.signIn.staticPassword);
       // fill values inside inputs of this form before shows to user
      if (baseSignUpModel.ui.signIn.staticPassword) {
        if (baseSignUpModel.logic.signIn.mobile) {
          $(".js-sign-in-static").find("form input#Mobile").val(baseSignUpModel.logic.signIn.mobile);
        }

        if (baseSignUpModel.logic.signIn.email) {
          $(".js-sign-in-static").find("form input#Email").val(baseSignUpModel.logic.signIn.email);
        }
      }

      $(".js-sign-in-email-password").toggle(baseSignUpModel.ui.signIn.email);

      $(".js-recovery-account").toggle(baseSignUpModel.ui.recovery.base);

      $(".js-sign-up-email-set-password").toggle(
        baseSignUpModel.ui.signUp.setEmailPassword
      );

      $(".js-sign-up-mobile-confirmation-set-password").toggle(
        baseSignUpModel.ui.signUp.setMobilePassword
      );

      $(".js-sign-up-mobile-confirmation").toggle(
        baseSignUpModel.ui.signUp.mobileConfirmation
      );

      $(".js-sign-up-mobile-confirmation-mobile-number").text(
        baseSignUpModel.logic.signUp.mobileNumber
      );

      $(".js-sign-up-mobile-final").toggle(
        baseSignUpModel.ui.signUp.mobileFinal
      );

      $(".js-sign-up-email-confirmation").toggle(
        baseSignUpModel.ui.signUp.emailFinal
      );

      $(".js-sign-up-email-confirmation-email").text(
        baseSignUpModel.logic.signUp.email
      );

      $(".js-sign-in-mobile-dynamic-password").toggle(
        baseSignUpModel.ui.signIn.dynamicPassword
      );
      $(".js-sign-in-email-dynamic-password").toggle(
        baseSignUpModel.ui.signIn.dynamicPasswordToEmail
      );

      $(".js-sign-in-mobile-dynamic-password-mobile-number").text(
        baseSignUpModel.logic.signIn.mobile ||
          baseSignUpModel.logic.signIn.email
      );
      $(".js-sign-in-mobile-dynamic-password-email").text(
        baseSignUpModel.logic.signIn.email
      );

      $(".js-sign-in-email-dynamic-password-email").text(
        baseSignUpModel.logic.signIn.email
      );

      $(".js-recovery-account-mobile").toggle(
        baseSignUpModel.ui.recovery.mobile
      );

      $(".js-recovery-account-mobile-mobile-number").text(
        baseSignUpModel.logic.recovery.mobile
      );

      $(".js-recovery-account-change-password").toggle(
        baseSignUpModel.ui.recovery.changePassword
      );

      $(".js-recovery-account-change-password-final").toggle(
        baseSignUpModel.ui.recovery.mobileFinal
      );

      $(".js-recovery-account-email-final-email").text(
        baseSignUpModel.logic.recovery.email
      );

      $(".js-recovery-account-email-final").toggle(
        baseSignUpModel.ui.recovery.emailFinal
      );

      //resend

      $(".js-sign-in-mobile-dynamic-password-re-send").toggleClass(
        "de-active",
        !baseSignUpModel.logic.signIn.isActiveResendButton
      );
      $(".js-sign-in-email-dynamic-password-re-send").toggleClass(
        "de-active",
        !baseSignUpModel.logic.signIn.isActiveResendButton
      );

      $(".js-timer-signIn-wrapper").toggleClass(
        "hide",
        baseSignUpModel.logic.signIn.isActiveResendButton
      );

      $(".js-sign-up-mobile-confirmation-re-send").toggleClass(
        "de-active",
        !baseSignUpModel.logic.signUp.isActiveResendButton
      );

      $(".js-timer-signUp-wrapper").toggleClass(
        "hide",
        baseSignUpModel.logic.signUp.isActiveResendButton
      );

      $(".js-recovery-account-re-send-mobile-code").toggleClass(
        "de-active",
        !baseSignUpModel.logic.recovery.isActiveResendButton
      );

      $(".js-timer-recovery-wrapper").toggleClass(
        "hide",
        baseSignUpModel.logic.recovery.isActiveResendButton
      );

      $(".js-sign-in-mobile-dynamic-password-re-send").toggleClass(
        "loading",
        baseSignUpModel.logic.signIn.isLoadingResendButton
      );

      $(".js-sign-up-mobile-confirmation-re-send").toggleClass(
        "loading",
        baseSignUpModel.logic.signUp.isLoadingResendButton
      );

      $(".js-recovery-account-re-send-mobile-code").toggleClass(
        "loading",
        baseSignUpModel.logic.recovery.isLoadingResendButton
      );
    }

    function createAccount() {
      pushHistory();
      baseSignUpModel.ui.signUp.base = true;
      baseSignUpModel.ui.baseSignUp = false;
      updateView();
    }

    function startRecoveryByMobileInSignIn() {
      pushHistory();
      baseSignUpModel.ui.recovery.base = true;
      baseSignUpModel.ui.signIn.staticPassword = false;
      baseSignUpModel.ui.signIn.mobile = false;
      updateView();
    }

    function startRecoveryInSignUpSignIn() {
      pushHistory();
      baseSignUpModel.ui.recovery.base = true;
      baseSignUpModel.ui.baseSignUp = false;
      updateView();
    }

    function sendDynamicPassword() {
      baseSignUpModel.logic.signIn.isActiveResendButton = false;

      if (!baseSignUpModel.logic.signIn.mobileIsChanged) {
        if (!isExpireDate(baseSignUpModel.logic.signIn.expireTime)) {
          pushHistory();
          baseSignUpModel.ui.signIn.dynamicPassword = true;
          baseSignUpModel.ui.signIn.mobile = false;
          updateView();
          return;
        }
      }

      baseSignUpModel.logic.signIn.mobileIsChanged = false;

      currentForm = $(".js-sign-in-mobile-send-dynamic-password-box");

      var model = { mobile: baseSignUpModel.logic.signIn.mobile };

      postRequest(
        baseSignUpModel.logic.url.sendDynamicMobilePassword,
        model,
        sendDynamicPasswordComplete
      );
    }

    function signInStaticPasswordMobile() {
      baseSignUpModel.ui.signIn.mobile = true;
      baseSignUpModel.ui.signIn.dynamicPassword = false;
      updateView();
    }

    function signInStaticPasswordPage() {
      let mobileInputValue = $(this).closest("form").find("#Mobile").val();
      let emailInputValue = $(this).closest("form").find("#Email").val();
      
      // save input's values to global model to recover when form change and can access to the new page
      if (mobileInputValue) {
        baseSignUpModel.logic.signIn.mobile = mobileInputValue;
      }
      if (emailInputValue) {
        baseSignUpModel.logic.signIn.email = emailInputValue;
      }

      pushHistory();
      baseSignUpModel.ui.baseSignUp = false;

      baseSignUpModel.ui.signIn.staticPassword = true;
      updateView();
      return;
    }

    function signInStaticPasswordEmail() {
      baseSignUpModel.ui.signIn.mobile = true;
      baseSignUpModel.ui.signIn.dynamicPasswordToEmail = false;
      updateView();
    }

    function sendDynamicPasswordComplete(data) {
      if (data.isSucceed) {
        if (data.captcha) {
          $(".js-sign-up-sign-in-enter")
            .find("#CaptchaDeText")
            .val(data.captcha.captchaDeText);
          $(".js-sign-up-sign-in-enter")
            .find("#CaptchaImage")
            .attr("src", data.captcha.captchaImage);
        }
        pushHistory();
        baseSignUpModel.logic.signIn.key = data.model.key;
        baseSignUpModel.ui.signIn.dynamicPassword = true;
        baseSignUpModel.ui.signIn.mobile = false;
        baseSignUpModel.ui.baseSignUp = false;
        baseSignUpModel.logic.signIn.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.signIn);

        updateView();
      } else {
        if (data.response && data.response.captcha) {
          $(".js-sign-up-sign-in-enter")
            .find("#CaptchaDeText")
            .val(data.response.captcha.captchaDeText);
          $(".js-sign-up-sign-in-enter")
            .find("#CaptchaImage")
            .attr("src", data.response.captcha.captchaImage);
        }

        if (data && data.messages) {
          showMessage(data.messages);
        }
      }
    }

    function sendDynamicPasswordByEmailComplete(data) {
      if (data.captcha) {
        $(".js-sign-up-sign-in-enter")
          .find("#CaptchaDeText")
          .val(data.captcha.captchaDeText);
        $(".js-sign-up-sign-in-enter")
          .find("#CaptchaImage")
          .attr("src", data.captcha.captchaImage);
      } else if (data.response && data.response.captcha) {
        $(".js-sign-up-sign-in-enter")
          .find("#CaptchaDeText")
          .val(data.response.captcha.captchaDeText);
        $(".js-sign-up-sign-in-enter")
          .find("#CaptchaImage")
          .attr("src", data.response.captcha.captchaImage);
      }

      if (data.isSucceed) {
        pushHistory();
        baseSignUpModel.logic.signIn.key = data.model.key;
        baseSignUpModel.ui.signIn.dynamicPasswordToEmail = true;
        baseSignUpModel.ui.signIn.mobile = false;
        baseSignUpModel.ui.baseSignUp = false;
        baseSignUpModel.logic.signIn.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.signIn);

        updateView();
      } else {
        if (data && data.messages) {
          showMessage(data.messages);
        }
      }
    }

    function sendDynamicPasswordAgain() {
      if (!baseSignUpModel.logic.signIn.isActiveResendButton) {
        return;
      }

      baseSignUpModel.logic.signIn.isActiveResendButton = false;
      baseSignUpModel.logic.signIn.isLoadingResendButton = true;

      updateView();

      currentForm = $(".js-sign-in-mobile-dynamic-password-continue");

      var model = { mobile: baseSignUpModel.logic.signIn.mobile };

      postRequest(
        baseSignUpModel.logic.url.sendDynamicMobilePassword,
        model,
        sendDynamicPasswordAgainComplete
      );
    }

    function sendDynamicPasswordAgainWithEmail() {
      if (!baseSignUpModel.logic.signIn.isActiveResendButton) {
        return;
      }

      baseSignUpModel.logic.signIn.isActiveResendButton = false;
      baseSignUpModel.logic.signIn.isLoadingResendButton = true;

      updateView();

      currentForm = $(".js-sign-in-email-dynamic-password-continue");

      var emailModel = {
        email: baseSignUpModel.logic.signIn.email
      };

      postRequest(
        baseSignUpModel.logic.url.sendDynamicEmailPassword,
        emailModel,
        sendDynamicPasswordByEmailComplete
      );
    }

    function sendDynamicPasswordAgainComplete(data) {
      baseSignUpModel.logic.signIn.isLoadingResendButton = false;

      if (data.isSucceed) {
        baseSignUpModel.logic.signIn.key = data.model.key;

        baseSignUpModel.logic.signIn.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.signIn);
      } else {
        setValidInterval(sectionTypes.signIn, true);
      }

      updateView();
    }

    function signInByDynamicPassword(password) {
      var model = {
        mobile: baseSignUpModel.logic.signIn.mobile,
        password: password,
        key: baseSignUpModel.logic.signIn.key,
        type: passwordTypes.dynamic
      };

      postRequest(
        baseSignUpModel.logic.url.signInByMobile,
        model,
        signInByDynamicPasswordComplete
      );
    }
    function signInByDynamicPasswordWithMobile(code) {
      var model = {
        mobile: baseSignUpModel.logic.signIn.mobile,
        code: code,
        key: baseSignUpModel.logic.signIn.key
      };

      postRequest(
        baseSignUpModel.ui.signIn.needTwoStepVerification ? baseSignUpModel.logic.url.verifyTwoFactorMobileTokenAndSignIn : baseSignUpModel.logic.url.verifyDynamicMobilePasswordAndSignIn,
        model,
        signInByDynamicPasswordComplete
      );
    }

    function signInByDynamicPasswordWithEmail(code) {
      var model = {
        email: baseSignUpModel.logic.signIn.email,
        code: code,
        key: baseSignUpModel.logic.signIn.key
      };

      postRequest(
        baseSignUpModel.ui.signIn.needTwoStepVerification ? baseSignUpModel.logic.url.verifyTwoFactorEmailTokenAndSignIn : baseSignUpModel.logic.url.verifyDynamicEmailPasswordAndSignIn,
        model,
        signInByDynamicPasswordComplete
      );
    }

    function signInByDynamicPasswordComplete(data, model) {
      if (data.isSucceed) {
        finalStepHandler(model);
      }
    }

    function signUpByMobileAndSetPassword(password, confirmPassword) {
      var model = {
        mobile: baseSignUpModel.logic.signUp.mobile,
        code: baseSignUpModel.logic.signUp.code,
        key: baseSignUpModel.logic.signUp.key,
        password: password
      };

      postRequest(
        baseSignUpModel.logic.url.signUpByMobileAndSetPassword,
        model,
        signUpByMobileCallbackAndSetPassword
      );
    }

    function signUpByMobileCallbackAndSetPassword(data) {
      if (data.isSuccess) {
        pushHistory();

        baseSignUpModel.ui.signUp.mobileSetPassword = false;
        baseSignUpModel.ui.signUp.final = true;

        updateView();
      }
    }

    function VerifyMobileVerificationCode(code) {
      baseSignUpModel.logic.signUp.code = code;

      var model = {
        key: baseSignUpModel.logic.signUp.key,
        mobile: baseSignUpModel.logic.signUp.mobile,
        code: code
      };

      postRequest(
        baseSignUpModel.logic.url.verifyMobileVerificationCode,
        model,
        VerifyMobileVerificationCodeComplete
      );
    }

    function VerifyMobileVerificationCodeComplete(data, model) {
      if (data.isSucceed) {
        if (isExpireDate(baseSignUpModel.logic.signUp.expireTime)) {
          finalStepHandler(model);
          return;
        }

        pushHistory();

        baseSignUpModel.logic.signUp.success = true;
        baseSignUpModel.ui.signUp.mobileConfirmation = false;
        baseSignUpModel.ui.signUp.setMobilePassword = true;

        updateView();
      }
    }

    function sendMobileVerificationCode() {
      if (!baseSignUpModel.logic.signUp.isActiveResendButton) {
        return;
      }

      baseSignUpModel.logic.signUp.isActiveResendButton = false;
      baseSignUpModel.logic.signUp.isLoadingResendButton = true;

      updateView();

      currentForm = $(".js-sign-up-mobile-confirmation-continue");

      startResendLoading();

      var model = { mobile: baseSignUpModel.logic.signUp.mobile };

      postRequest(
        baseSignUpModel.logic.url.sendMobileVerificationCode,
        model,
        SendMobileVerificationCodeComplete
      );
    }

    function SendMobileVerificationCodeComplete(data) {
      baseSignUpModel.logic.signUp.isLoadingResendButton = false;

      if (data.isSucceed) {
        baseSignUpModel.logic.signUp.key = data.model.key;

        baseSignUpModel.logic.signIn.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.signUp);
      } else {
        setValidInterval(sectionTypes.signUp, true);
      }

      updateView();
    }

    function signUpUserNotFindByMobile(mobile) {
      var mobileIsChanged = baseSignUpModel.logic.signUp.mobile !== mobile;

      baseSignUpModel.logic.signUp.mobileIsChanged = mobileIsChanged;

      baseSignUpModel.logic.signUp.isActiveResendButton = false;

      if (!mobileIsChanged) {
        if (!isExpireDate(baseSignUpModel.logic.signUp.expireTime)) {
          pushHistory();

          baseSignUpModel.ui.signUp.base = false;
          baseSignUpModel.ui.signIn.mobile = true;

          updateView();

          return;
        }
      }

      baseSignUpModel.logic.signUp.mobile = mobile;

      baseSignUpModel.logic.signUp.mobileNumber = mobile;

      updateView();

      var model = {
        mobile: mobile,
        CaptchaInputText: $("#CaptchaInputText").val(),
        CaptchaDeText: $("#CaptchaDeText").val()
      };

      postRequest(
        baseSignUpModel.logic.url.findUserByMobile,
        model,
        signUpUserNotFindByMobileComplete,
        true
      );
    }

    function signUpUserNotFindByMobileComplete(data) {
      if (data.isSucceed) {
        if (data.model.exist) {
          pushHistory();

          baseSignUpModel.ui.signUp.base = false;
          baseSignUpModel.ui.signIn.mobile = true;

          baseSignUpModel.logic.signIn.mobile =
            baseSignUpModel.logic.signUp.mobileNumber;

          updateView();

          //because current form should changed
          endLoading();

          currentForm = $(".js-sign-in-mobile-continue");

          showMessage([
            {
              type: 4,
              message: "شما قبلا با این شماره ثبت نام کرده اید لطفا وارد شوید"
            }
          ]);
        } else {
          var model = {
            mobile: baseSignUpModel.logic.signUp.mobileNumber
          };

          postRequest(
            baseSignUpModel.logic.url.signUpByMobile,
            model,
            signUpByMobileComplete
          );
        }
      }
    }

    function signUpByMobileComplete(data) {
      if (data.isSucceed) {
        pushHistory();

        baseSignUpModel.logic.signUp.key = data.model.key;
        baseSignUpModel.ui.signUp.base = false;
        baseSignUpModel.ui.signUp.mobileConfirmation = true;

        baseSignUpModel.logic.signUp.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.signUp);

        updateView();
      }
    }

    function verifyMobileVerificationCodeAndSetPassword(password) {
      var model = {
        mobile: baseSignUpModel.logic.signUp.mobile,
        password: password,
        key: baseSignUpModel.logic.signUp.key,
        code: baseSignUpModel.logic.signUp.code
      };

      postRequest(
        baseSignUpModel.logic.url.verifyMobileVerificationCodeAndSetPassword,
        model,
        verifyMobileVerificationCodeAndSetPasswordComplete
      );
    }

    function verifyMobileVerificationCodeAndSetPasswordComplete(data, model) {
      if (data.isSucceed) {
        pushHistory();

        baseSignUpModel.ui.signUp.mobileFinal = true;
        baseSignUpModel.ui.signUp.setMobilePassword = false;

        updateView();

        finalStepHandler(model);
      }
    }

    function signUpUserNotFindByEmail(email) {
      baseSignUpModel.logic.signUp.email = email;

      baseSignUpModel.logic.signIn.email = email;

      var model = { email: baseSignUpModel.logic.signUp.email };

      postRequest(
        baseSignUpModel.logic.url.findUserByEmail,
        model,
        signUpUserNotFindByEmailComplete
      );
    }

    function signUpUserNotFindByEmailComplete(data) {
      if (data.isSucceed) {
        if (data.model.exist) {
          pushHistory();

          baseSignUpModel.ui.signUp.base = false;
          baseSignUpModel.ui.signIn.email = true;

          updateView();

          //because current form should changed
          endLoading();

          currentForm = $(".js-sign-in-email-password-continue");

          showMessage([
            {
              type: 4,
              message: "ایمیل وارد شده قبلا به ثبت رسیده است لطفا وارد شوید"
            }
          ]);
        } else {
          pushHistory();

          baseSignUpModel.ui.signUp.base = false;
          baseSignUpModel.ui.signUp.setEmailPassword = true;

          updateView();
        }
      }
    }

    function signUpByEmail(password, confirmPassword) {
      var model = {
        email: baseSignUpModel.logic.signUp.email,
        password
      };

      postRequest(
        baseSignUpModel.logic.url.signUpByEmail,
        model,
        signUpByEmailComplete
      );
    }

    function signUpByEmailComplete(data) {
      if (data.isSucceed) {
        pushHistory();

        baseSignUpModel.logic.signUp.success = true;
        baseSignUpModel.ui.signUp.setEmailPassword = false;
        baseSignUpModel.ui.signUp.emailFinal = true;

        updateView();
      }
    }

    function enterAccountForSignIn() {
      currentForm = $(".js-sign-up-sign-in-static-password");

      var captchaNumber = $(".js-sign-up-sign-in-static-password")
        .find("#CaptchaDeText")
        .val();
      var captchaValue = $(".js-sign-up-sign-in-static-password")
        .find("#CaptchaInputText")
        .val();

      if (
        (baseSignUpModel.logic.signIn.byMobile &&
          !baseSignUpModel.logic.signIn.byEmail) ||
        (baseSignUpModel.logic.signIn.byMobile &&
          window.activeType === activeTypes.mobile)
      ) {
        var Mobile = convertFaToEnNumber(
          $(".js-sign-up-sign-in").find("[name$='Mobile']").val()
        );

        var countryCode = $(".js-sign-up-sign-in")
          .find(".js-country-code-placeholder")
          .val();

        var mobileIsValid = isValidMobile(Mobile);

        if (mobileIsValid) {
          var mobileIsChanged = baseSignUpModel.logic.signIn.mobile !== Mobile;

          baseSignUpModel.logic.signIn.mobileIsChanged = mobileIsChanged;

          var mobileModel = {
            mobile: Mobile,
            CaptchaInputText: captchaValue,
            CaptchaDeText: captchaNumber,
            CountryCode: countryCode
          };
          baseSignUpModel.logic.signIn.email = "";
          baseSignUpModel.logic.signIn.mobile = Mobile;

          postRequest(
            baseSignUpModel.logic.url.sendDynamicMobilePassword,
            mobileModel,
            sendDynamicPasswordComplete
          );

          return;
        }

        showMessage([
          {
            type: 8,
            message: "فرمت شماره موبایل وارد شده صحیح نمی‌باشد"
          }
        ]);
        return;
      }

      if (
        (baseSignUpModel.logic.signIn.byEmail &&
          !baseSignUpModel.logic.signIn.byMobile) ||
        (baseSignUpModel.logic.signIn.byEmail &&
          window.activeType === activeTypes.email)
      ) {
        var Email = convertFaToEnNumber(
          $(".js-sign-up-sign-in").find("[name$='Email']").val()
        );
        var emailIsValid = isValidEmail(Email);

        if (emailIsValid) {
          var emailModel = {
            email: Email,
            CaptchaInputText: captchaValue,
            CaptchaDeText: captchaNumber
          };

          baseSignUpModel.logic.signIn.email = Email;
          baseSignUpModel.logic.signIn.mobile = "";
          postRequest(
            baseSignUpModel.logic.url.sendDynamicEmailPassword,
            emailModel,
            sendDynamicPasswordByEmailComplete
          );

          return;
        }

        showMessage([
          {
            type: 8,
            message: "فرمت ایمیل وارد شده صحیح نمی‌باشد"
          }
        ]);

        return;
      }

      showMessage([
        {
          type: 8,
          message: "فرمت شماره موبایل یا ایمیل وارد شده صحیح نمی‌باشد"
        }
      ]);
      return;
    }

    function enterAccountForStaticPass() {
      var emailOrMobile = convertFaToEnNumber(
        $(".js-sign-up-sign-in").find("[name$='EmailOrMobile']").val()
      );

      baseSignUpModel.ui.baseSignUp = false;

      baseSignUpModel.ui.signIn.staticPassword = true;

      $(".js-sign-in-staticPassword").find("#EmailOrMobile").val(emailOrMobile);
      updateView();
    }

    function signInByStaticPass(mobile, email, countryCode, password) {
      if (
        (baseSignUpModel.logic.signIn.byMobile &&
          !baseSignUpModel.logic.signIn.byEmail) ||
        (baseSignUpModel.logic.signIn.byMobile &&
          window.activeType === activeTypes.mobile)
      ) {
        var mobileIsValid = isValidMobile(mobile);

        if (mobileIsValid) {
          var model = {
            mobile: mobile,
            password: password,
            countryCode: countryCode
          };

          postRequest(
            baseSignUpModel.logic.url.signInByMobile,
            model,
            manageMobileSignInFlow
          );
          return;
        }

        showMessage([
          {
            type: 8,
            message: "فرمت شماره موبایل وارد شده صحیح نمی‌باشد"
          }
        ]);
        return;
      }

      if (
        (baseSignUpModel.logic.signIn.byEmail &&
          !baseSignUpModel.logic.signIn.byMobile) ||
        (baseSignUpModel.logic.signIn.byEmail &&
          window.activeType === activeTypes.email)
      ) {
        var emailIsValid = isValidEmail(email);

        if (emailIsValid) {
          var emailModel = {
            email: email,
            password: password
          };

          postRequest(
            baseSignUpModel.logic.url.signInByEmail,
            emailModel,
            manageEmailSignInFlow
          );
          return;
        }

        showMessage([
          {
            type: 8,
            message: "فرمت ایمیل وارد شده صحیح نمی‌باشد"
          }
        ]);

        return;
      }

      showMessage([
        {
          type: 8,
          message: "فرمت ایمیل یا شماره موبایل صحیح نمی‌باشد"
        }
      ]);
      return;
    }

    function signInByEmailNotFindUserComplete(data) {
      if (data.isSucceed) {
        pushHistory();

        if (data.model.exist) {
          baseSignUpModel.ui.baseSignUp = false;
          baseSignUpModel.ui.signIn.email = true;
        } else {
          baseSignUpModel.ui.signUp.base = true;
          baseSignUpModel.ui.baseSignUp = false;
        }

        updateView();
      }
    }

    function signInByMobileNotFindUserComplete(data) {
      if (data.isSucceed) {
        if (!isExpireDate(baseSignUpModel.logic.signIn.expireTime)) {
          pushHistory();
          baseSignUpModel.ui.baseSignUp = false;

          baseSignUpModel.ui.signIn.dynamicPassword = true;

          updateView();

          return;
        }
      }
    }

    function signInByMobile(password) {
      if (baseSignUpModel.logic.signIn.mobile) {
        var model = {
          mobile: baseSignUpModel.logic.signIn.mobile,
          password: password
        };

        postRequest(
          baseSignUpModel.logic.url.signInByMobile,
          model,
          signInByMobileComplete
        );
      } else {
        signInByEmail(password);
      }
    }

    function manageMobileSignInFlow(data, model) {
      if(data.model?.requiresTwoStepVerification) prepareTowFactorSignInByMobile(data, model.mobile)
      else signInByMobileComplete(data, model)
    }

    function prepareTowFactorSignInByMobile(data, mobile) {
      baseSignUpModel.logic.signIn.key = data.model.key
      baseSignUpModel.logic.signIn.mobile = mobile
      baseSignUpModel.logic.signIn.email = ''
      baseSignUpModel.ui.signIn.staticPassword = false
      baseSignUpModel.ui.signIn.dynamicPassword = true
      baseSignUpModel.ui.signIn.needTwoStepVerification = true
      baseSignUpModel.logic.signIn.expireTime = createExpireDate(
        data.model.expireSeconds
      );
      updateTimer(data.model.expireSeconds, sectionTypes.signIn);
      updateView();
    }

    function signInByMobileComplete(data, model) {
      if (data.isSucceed) {
        finalStepHandler(model);
      }
    }

    function signInByEmail(password) {
      var model = {
        email: baseSignUpModel.logic.signIn.email,
        password: password
      };

      postRequest(
        baseSignUpModel.logic.url.signInByEmail,
        model,
        signInByEmailComplete
      );
    }

    function manageEmailSignInFlow(data, model) {
      if(data.model?.requiresTwoStepVerification) prepareTowFactorSignInByEmail(data, model.email)
      else signInByEmailComplete(data, model)
    }

    function prepareTowFactorSignInByEmail (data, email) {
      baseSignUpModel.logic.signIn.key = data.model.key
      baseSignUpModel.logic.signIn.mobile = ''
      baseSignUpModel.logic.signIn.email = email
      baseSignUpModel.ui.signIn.staticPassword = false
      baseSignUpModel.ui.signIn.dynamicPasswordToEmail = true
      baseSignUpModel.ui.signIn.needTwoStepVerification = true
      baseSignUpModel.logic.signIn.expireTime = createExpireDate(
        data.model.expireSeconds
      );
      updateTimer(data.model.expireSeconds, sectionTypes.signIn);
      updateView();
    }

    function signInByEmailComplete(data, model) {
      if (data.isSucceed) {
        finalStepHandler(model);
      }
    }

    //Recovery section

    function reSendMobileRecoveryCode() {
      if (!baseSignUpModel.logic.recovery.isActiveResendButton) {
        return;
      }

      baseSignUpModel.logic.recovery.isActiveResendButton = false;
      baseSignUpModel.logic.recovery.isLoadingResendButton = true;

      updateView();

      currentForm = $(".js-recovery-account-send-mobile-code");

      var model = {
        mobile: baseSignUpModel.logic.recovery.mobile,
        countryCode: baseSignUpModel.logic.recovery.countryCode
      };

      postRequest(
        baseSignUpModel.logic.url.sendDynamicMobilePassword,
        model,
        reSendMobileRecoveryCodeComplete
      );
    }

    function reSendMobileRecoveryCodeComplete(data) {
      baseSignUpModel.logic.recovery.isLoadingResendButton = false;

      if (data.isSucceed) {
        baseSignUpModel.logic.recovery.key = data.model.key;

        baseSignUpModel.logic.recovery.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.recovery);
      } else {
        setValidInterval(sectionTypes.recovery, true);
      }

      updateView();
    }

    function sendEmailRecoveryLink(email) {
      baseSignUpModel.logic.recovery.email = email;
      var captchaNumber = $(".js-recovery-account-send-email-link")
        .find("#CaptchaDeText")
        .val();
      var captchaValue = $(".js-recovery-account-send-email-link")
        .find("#CaptchaInputText")
        .val();
      var model = {
        email: email,
        CaptchaInputText: captchaValue,
        CaptchaDeText: captchaNumber
      };

      postRequest(
        baseSignUpModel.logic.url.sendRecoveryAccountCodeByEmail,
        model,
        sendEmailRecoveryLinkComplete
      );
    }

    function sendEmailRecoveryLinkComplete(data) {
      if (data.isSucceed) {
        if (data.captcha) {
          $(".js-recovery-account-send-email-link")
            .find("#CaptchaDeText")
            .val(data.captcha.captchaDeText);
          $(".js-recovery-account-send-email-link")
            .find("#CaptchaImage")
            .attr("src", data.captcha.captchaImage);
        }
        pushHistory();

        baseSignUpModel.ui.recovery.base = false;
        baseSignUpModel.ui.recovery.emailFinal = true;

        updateView();
      } else {
        if (data.response && data.response.captcha) {
          $(".js-recovery-account-send-email-link")
            .find("#CaptchaDeText")
            .val(data.response.captcha.captchaDeText);
          $(".js-recovery-account-send-email-link")
            .find("#CaptchaImage")
            .attr("src", data.response.captcha.captchaImage);
        }

        if (data && data.messages) {
          showMessage(data.messages);
        }
      }
    }

    function sendMobileRecoveryCode(mobile, countryCode) {
      var mobileIsChanged = baseSignUpModel.logic.recovery.mobile !== mobile;

      baseSignUpModel.logic.recovery.mobileIsChanged = mobileIsChanged;
      baseSignUpModel.logic.recovery.isActiveResendButton = false;
      var captchaNumber = $(".js-recovery-account-send-mobile-code")
        .find("#CaptchaDeText")
        .val();
      var captchaValue = $(".js-recovery-account-send-mobile-code")
        .find("#CaptchaInputText")
        .val();

      if (!mobileIsChanged) {
        if (!isExpireDate(baseSignUpModel.logic.recovery.expireTime)) {
          pushHistory();

          baseSignUpModel.ui.recovery.base = false;
          baseSignUpModel.ui.recovery.mobile = true;

          updateView();

          return;
        }
      }

      baseSignUpModel.logic.recovery.mobile = mobile;
      baseSignUpModel.logic.recovery.countryCode = countryCode;

      var model = {
        mobile: mobile,
        countryCode: countryCode,
        CaptchaInputText: captchaValue,
        CaptchaDeText: captchaNumber
      };

      postRequest(
        baseSignUpModel.logic.url.sendRecoveryAccountCodeByMobile,
        model,
        sendMobileRecoveryCodeComplete
      );
    }

    function sendMobileRecoveryCodeComplete(data) {
      if (data.isSucceed) {
        if (data.captcha) {
          $(".js-recovery-account-send-mobile-code")
            .find("#CaptchaDeText")
            .val(data.captcha.captchaDeText);
          $(".js-recovery-account-send-mobile-code")
            .find("#CaptchaImage")
            .attr("src", data.captcha.captchaImage);
        }
        pushHistory();

        baseSignUpModel.logic.recovery.key = data.model.key;
        baseSignUpModel.ui.recovery.base = false;
        baseSignUpModel.ui.recovery.mobile = true;

        baseSignUpModel.logic.recovery.expireTime = createExpireDate(
          data.model.expireSeconds
        );

        updateTimer(data.model.expireSeconds, sectionTypes.recovery);

        updateView();
      } else {
        if (data.response.captcha) {
          $(".js-recovery-account-send-mobile-code")
            .find("#CaptchaDeText")
            .val(data.response.captcha.captchaDeText);
          $(".js-recovery-account-send-mobile-code")
            .find("#CaptchaImage")
            .attr("src", data.response.captcha.captchaImage);
        }
      }
    }

    function verifyMobileRecoveryCode(code, countryCode) {
      baseSignUpModel.ui.recovery.mobile = false;
      baseSignUpModel.logic.recovery.code = code;

      var model = {
        mobile: baseSignUpModel.logic.recovery.mobile,
        code: code,
        countryCode,
        key: baseSignUpModel.logic.recovery.key
      };

      postRequest(
        baseSignUpModel.logic.url.verifyRecoveryAccountCodeByMobile,
        model,
        verifyMobileRecoveryCodeComplete
      );
    }

    function verifyMobileRecoveryCodeComplete(data, model) {
      if (data.isSucceed) {
        if (isExpireDate(baseSignUpModel.logic.recovery.expireTime)) {
          finalStepHandler(model);
          return;
        }

        pushHistory();

        baseSignUpModel.ui.recovery.mobile = false;
        baseSignUpModel.ui.recovery.changePassword = true;

        updateView();

        // seconds set manually because just to clear previous interval and it couldn't be null or zero
        updateTimer(30, sectionTypes.recovery, true);
      } else {
        baseSignUpModel.ui.recovery.mobile = true;
      }
    }

    function verifyMobileRecoveryCodeAndChangePassword(
      password,
      confirmPassword
    ) {
      var model = {
        mobile: baseSignUpModel.logic.recovery.mobile,
        code: baseSignUpModel.logic.recovery.code,
        key: baseSignUpModel.logic.recovery.key,
        password: password
      };

      postRequest(
        baseSignUpModel.logic.url
          .VerifyRecoveryAccountCodeByMobileAndChangePassword,
        model,
        verifyMobileRecoveryCodeAndChangePasswordComplete
      );
    }

    function verifyMobileRecoveryCodeAndChangePasswordComplete(data, model) {
      if (data.isSucceed) {
        pushHistory();

        window.showAlert([
          {
            type: 4,
            message: "بعد از تغییر رمز می‌بایست مجددا ورود کنید"
          }
        ]);

        baseSignUpModel.ui.recovery.changePassword = false;
        baseSignUpModel.ui.baseSignUp = true;

        updateView();
      }
    }

    //End recovery section

    //start history section

    function goBack() {
      clearMessages();

      if (baseSignUpModel.logic.loading) {
        return;
      }

      if (baseSignUpModel.ui.signUp.emailFinal) {
        return gotoBasePage();
      }

      if (
        baseSignUpModel.ui.signUp.setMobilePassword ||
        baseSignUpModel.ui.recovery.changePassword
      ) {
        var model = {
          mobile: baseSignUpModel.logic.recovery.mobile,
          email: baseSignUpModel.logic.recovery.email,
          countryCode: baseSignUpModel.logic.recovery.countryCode
        };

        finalStepHandler(model);

        return;
      }

      // save input's values to global model to recover when form change and can access to the new page
      if (baseSignUpModel.ui.signIn.staticPassword) {
        let mobileInputValue = $(".js-sign-in-static").find("form input#Mobile").val();
        let emailInputValue = $(".js-sign-in-static").find("form input#Email").val();

        if (mobileInputValue) {
          baseSignUpModel.logic.signIn.mobile = mobileInputValue;
        }

        if (emailInputValue) {
          baseSignUpModel.logic.signIn.email = emailInputValue;
        }
      }

      var uiModel = popHistory();

      baseSignUpModel.logic.loading = false;

      baseSignUpModel.ui = uiModel;

      updateView();
    }

    function pushHistory() {
      var copyOfModel = JSON.parse(JSON.stringify(baseSignUpModel));

      historyModels.push(copyOfModel.ui);
    }

    function popHistory() {
      var popModel = historyModels.pop();

      while (JSON.stringify(baseSignUpModel.ui) === JSON.stringify(popModel)) {
        popModel = historyModels.pop();
      }

      return popModel;
    }

    function gotoBasePage() {
      var firstPageModel = JSON.parse(JSON.stringify(firstUiModel));

      baseSignUpModel.ui = firstPageModel;

      updateView();
    }

    //end history section

    //start section timer

    function updateTimer(seconds, sectionType, justClearInterval = false) {
      var interval = getValidInterval(sectionType);

      if (!seconds) {
        return;
      }

      var lastDate = new Date();

      var newlastDate = new Date(lastDate);

      newlastDate.setSeconds(newlastDate.getSeconds() + seconds);

      if (interval) {
        clearInterval(interval);

        setValidInterval(sectionType, null);

        if (justClearInterval) return;
      }

      interval = setInterval(function () {
        var remainingTime = getRemainingTime(
          newlastDate,
          timerEnded,
          sectionType
        );

        if (remainingTime) {
          updateTimerElement(sectionType, remainingTime);
        }
      }, 200);

      setValidInterval(sectionType, interval);
    }

    function getValidInterval(sectionType) {
      switch (sectionType) {
        case sectionTypes.signIn:
          return baseSignUpModel.logic.signIn.interval;
        case sectionTypes.signUp:
          return baseSignUpModel.logic.signUp.interval;
        case sectionTypes.recovery:
          return baseSignUpModel.logic.recovery.interval;
      }
    }

    function setValidInterval(sectionType, value) {
      switch (sectionType) {
        case sectionTypes.signIn:
          baseSignUpModel.logic.signIn.interval = value;
          break;
        case sectionTypes.signUp:
          baseSignUpModel.logic.signUp.interval = value;
          break;
        case sectionTypes.recovery:
          baseSignUpModel.logic.recovery.interval = value;
      }
    }

    function updateTimerElement(sectionType, value) {
      switch (sectionType) {
        case sectionTypes.signIn:
          $(".js-timer-signIn").text(value);
          break;
        case sectionTypes.signUp:
          $(".js-timer-signUp").text(value);
          break;
        case sectionTypes.recovery:
          $(".js-timer-recovery").text(value);
      }
    }

    function setResendButton(sectionType, value) {
      switch (sectionType) {
        case sectionTypes.signIn:
          baseSignUpModel.logic.signIn.isActiveResendButton = value;
          break;
        case sectionTypes.signUp:
          baseSignUpModel.logic.signUp.isActiveResendButton = value;
          break;
        case sectionTypes.recovery:
          baseSignUpModel.logic.recovery.isActiveResendButton = value;
      }
    }

    function timerEnded(sectionType) {
      var interval = getValidInterval(sectionType);

      clearInterval(interval);

      setValidInterval(sectionType, null);

      if (
        baseSignUpModel.ui.recovery.changePassword ||
        baseSignUpModel.ui.signUp.setMobilePassword
      ) {
        var model = {
          mobile: baseSignUpModel.logic.recovery.mobile,
          email: baseSignUpModel.logic.recovery.email,
          countryCode: baseSignUpModel.logic.recovery.countryCode
        };

        finalStepHandler(model);
      }

      setResendButton(sectionType, true);

      updateView();
    }

    function getRemainingTime(lastDate, completedFuncTime, type) {
      var baseDate = new Date();

      if (lastDate < baseDate) {
        completedFuncTime(type);

        return formatTime(0, 0);
      }

      var allSeconds = Math.abs(lastDate.getTime() - baseDate.getTime()) / 1000;

      var minutes = Math.floor(allSeconds / 60);

      var seconds = Math.floor(allSeconds % 60);

      return formatTime(minutes, seconds);
    }

    function formatTime(minutes, seconds) {
      return (
        (minutes < 10 ? "0" + minutes : minutes) +
        " : " +
        (seconds < 10 ? "0" + seconds : seconds)
      );
    }

    //end section timer

    //start section message

    function clearMessages() {
      $(".js-signup-message-box").html("");
    }

    function showMessage(messages) {
      if (!(messages.length > 0)) {
        return;
      }

      var allMessages = [];

      for (var i = 0; i < messages.length; i++) {
        var messageObject = getMessageObject(messages[i].type);

        $(messageObject).attr("id", null);
        $(messageObject).attr("style", null);

        var messageText = messages[i].message;

        messageObject.html(messageObject.html() + messageText);

        allMessages.push(messageObject);
      }

      $(currentForm).find(".js-signup-message-box").html(allMessages);
    }

    function getMessageObject(type) {
      switch (type) {
        case 1:
          return $("#js-base-success").clone();
        case 2:
          return $("#js-base-primary").clone();
        case 4:
          return $("#js-base-warning").clone();
        case 8:
          return $("#js-base-danger").clone();
        default:
      }
    }

    //end section message

    function startLoading() {
      baseSignUpModel.logic.loading = true;

      $(currentForm).find("button").addClass("disable");
    }

    function endLoading() {
      baseSignUpModel.logic.loading = false;

      $(currentForm).find("button").removeClass("disable");
    }

    function startResendLoading() {
      $(".js-resend").addClass("loading");
    }

    function reloadPage(url = null) {
      if (url) {
        window.parent.location = url;
      } else {
        location.reload();
      }
    }

    function finalStepHandler(model) {
      if ($(".js-sign-up-modal").length) {
        window.searchInitialize.mobile = model?.mobile || null;
        window.searchInitialize.email = model?.email || null;
        window.searchInitialize.countryCode = model?.countryCode || null;
        window.searchInitialize.isUserAuthenticated =
          model?.mobile || model?.email ? true : false;
        window.hideSignUpModal();
        window.submitHandler();
      } else {
        getCompanies();
      }
    }

    function getCompanies() {
      getRequest(baseSignUpModel.logic.url.getCompanies, getCompaniesComplete);
    }

    function getCompaniesComplete(data) {
      const url =
        data.model.length > 0
          ? baseSignUpModel.logic.url.companies
          : baseSignUpModel.logic.url.return;
      reloadPage(url);
    }

    function createExpireDate(seconds) {
      var currentDate = new Date();

      currentDate.setSeconds(currentDate.getSeconds() + seconds);

      return currentDate;
    }

    function isExpireDate(date) {
      if (date) {
        return date < new Date();
      }

      return true;
    }

    function isValidEmail(email) {
      return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
    }

    function isValidMobile(mobile) {
      var validate = isValidIranianMobile(mobile);
      return validate ? true : /\+?\(?\d{2,4}\)?[\d-]{5,}/.test(mobile);
    }

    function isValidIranianMobile(mobile) {
      return /^(\+98|0)?9[\d]{2}[-.\s]?\d{3}[-.\s]?\d{4}\b/.test(mobile);
    }

    function postRequest(urlAction, model, callBackFunction) {
      startLoading();

      if (baseSignUpModel.logic.isActiveRecaptcha) {
        var recaptchaCallBackFunction = function () {
          model[baseSignUpModel.logic.reCaptchaInputName] = $(
            "#" + baseSignUpModel.logic.recaptchaElementId + ""
          ).val();

          sendRequest(urlAction, model, callBackFunction);
        };

        window["" + baseSignUpModel.logic.recaptchaFunctionName + ""](
          recaptchaCallBackFunction
        );
      } else {
        sendRequest(urlAction, model, callBackFunction);
      }
    }

    function sendRequest(urlAction, model, callBackFunction) {
      $.post(urlAction, model)
        .done(function (data) {
          callBackFunction(data, model);
        })
        .fail(function (error) {
          callBackFunction({
            isSuccess: false,
            response: { ...error.responseJSON }
          });
        })
        .always(function (data, statusText, xhr) {
          endLoading();

          var response = null;

          if (xhr.status === 200) {
            response = data;
          } else {
            response = data.responseJSON;
          }

          if (response && response.messages) {
            showMessage(response.messages);
          }
        });
    }

    function getRequest(urlAction, callBackFunction) {
      startLoading();

      $.get(urlAction)
        .done(function (data) {
          callBackFunction(data);
        })
        .fail(function () {
          callBackFunction({ isSuccess: false });
        })
        .always(function (data, statusText, xhr) {
          endLoading();

          var response = null;

          if (xhr.status === 200) {
            response = data;
          } else {
            response = data.responseJSON;
          }

          if (response && response.messages) {
            showMessage(response.messages);
          }
        });
    }

    // convert persian number to en number
    function convertFaToEnNumber(text) {
      if (text) {
        return text.replace(/[۰-۹]/g, function (chr) {
          var persian = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
          return persian.indexOf(chr);
        });
      } else {
        return text;
      }
    }

    document.querySelectorAll(".js-switch-mobile").forEach(function (node) {
      node.addEventListener("change", function (e) {
        clearMessages();

        if (!e.target.checked) {
          window.activeType = activeTypes.email;
          document
            .querySelectorAll(".js-switch-mobile")
            .forEach(function (switchNode) {
              switchNode.checked = false;

              switchNode
                .closest(".sign-up__item")
                .querySelector("input[name='Mobile']")
                .closest(".sign-up__input")
                .classList.add("hide");
              switchNode
                .closest(".sign-up__item")
                .querySelector("input[name='Email']")
                .closest(".sign-up__input")
                .classList.remove("hide");
            });

          return;
        } else {
          window.activeType = activeTypes.mobile;

          document
            .querySelectorAll(".js-switch-mobile")
            .forEach(function (switchNode) {
              switchNode.checked = true;

              switchNode
                .closest(".sign-up__item")
                .querySelector("input[name='Email']")
                .closest(".sign-up__input")
                .classList.add("hide");
              switchNode
                .closest(".sign-up__item")
                .querySelector("input[name='Mobile']")
                .closest(".sign-up__input")
                .classList.remove("hide");
            });

          return;
        }
      });
    });
  };
})();
